export default __webpack_public_path__ + "static/vouchPlaceholder-14d56852b99c9752681ce40656c81acf.webp";